module.exports = __webpack_public_path__ + "img/experience-support.a55884a6.png";